import { render, staticRenderFns } from "./DS_Benefit.vue?vue&type=template&id=5ee8d411&"
import script from "./DS_Benefit.vue?vue&type=script&lang=js&"
export * from "./DS_Benefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports